import {Component, Input, OnInit} from '@angular/core';
import {NavigationExtras, Router} from '@angular/router';

@Component({
  selector: 'app-point',
  templateUrl: './point.component.html',
  styleUrls: ['./point.component.scss'],
})
export class PointComponent implements OnInit {
  @Input() animate = false;
  @Input() route: { commands: any[]; extras?: NavigationExtras } = {commands: []};
  @Input() value: number;
  constructor(
    private router: Router
  ) { }

  ngOnInit() {}

  goToRoute() {
    this.router.navigate(this.route.commands, this.route.extras);
  }
}
